import React, { useEffect, useMemo, useCallback } from "react";
import { Input, Button } from "antd";
import {
  SearchOutlined,
  MoreOutlined,
  FileSyncOutlined,
} from "@ant-design/icons";
import { connect } from "react-redux";
import { Spin } from "antd";
import { useHistory } from "react-router-dom";

import { Table } from "../../components";
import {
  Container,
  SpaceBetween,
  TableContainer,
  TableButtonsContainer,
} from "./styles";
import {
  getLoans,
  setLoan,
  updateLoanStatus,
} from "../../state/actions/loanActions";
import { getStatusText, getStatusStyles } from "./helpers";
const constants = require("../../constants");
const { helpers } = require("../../utils");

const size = "small";

function Users(props) {
  const {
    loans,
    loadingGetLoans,
    getLoans: getAllLoans,
    updateLoanStatus: changeLoanStatus,
    setLoan: setLoanToState,
  } = props;
  const history = useHistory();

  useEffect(() => {
    async function getAllLoanApplications() {
      try {
        await getAllLoans();
      } catch (e) {
        helpers.displayMessage(e);
      }
    }
    getAllLoanApplications();
  }, [getAllLoans]);

  const handlesetLoanReview = useCallback(
    async (loan) => {
      const status = constants.values.loans.status.REVIEWING_STATUS_NUMBER;
      try {
        await changeLoanStatus(loan?._id, { status });
      } catch (e) {
        helpers.displayMessage(e);
      }
    },
    [changeLoanStatus]
  );
  const handleClickLoan = useCallback(
    (loan) => {
      setLoanToState(loan);
      history.push(`/dashboard/loans/${loan?._id}`);
    },
    [history, setLoanToState]
  );

  const columns = useMemo(() => {
    return [
      {
        title: "Loan number",
        dataIndex: "loan_number",
        key: "loan_number",
      },
      {
        title: "Name",
        dataIndex: "personal_details",
        key: "name",
        render: (personal_details) => {
          return (
            <p>
              {personal_details?.first_name} {personal_details?.last_name}
            </p>
          );
        },
      },
      {
        title: "Loan Amount",
        dataIndex: "financial_details",
        key: "loan_amount",
        render: (row) => {
          return <p>{helpers.toCurrency(row?.loan_amount)}</p>;
        },
      },
      {
        title: "Loan Status",
        dataIndex: "status",
        key: "status",
        render: (status) => (
          <p style={getStatusStyles(status)}>{getStatusText(status)}</p>
        ),
      },
      {
        title: "Approved Amount",
        dataIndex: "approved_amount",
        key: "approved_amount",
        render: (approved_amount) => (
          <p style={{ width: "100px", textAlign: "center" }}>
            {approved_amount ? helpers.toCurrency(approved_amount) : "-"}
          </p>
        ),
      },
      {
        title: "Actions",
        key: "actions",
        render: (loan) => {
          return (
            <div style={{ width: "80px" }}>
              <SpaceBetween>
                <Button
                  disabled={
                    loan?.status !==
                    constants.values.loans.status.PENDING_STATUS_NUMBER
                  }
                  icon={<FileSyncOutlined />}
                  onClick={() => handlesetLoanReview(loan)}
                  size={size}
                />
                <Button
                  shape="round"
                  icon={<MoreOutlined />}
                  size={size}
                  onClick={() => handleClickLoan(loan)}
                ></Button>
              </SpaceBetween>
            </div>
          );
        },
      },
    ];
  }, [handlesetLoanReview, handleClickLoan]);

  if (loadingGetLoans) {
    return (
      <div className="spin-contain">
        <Spin delay={100} size="large" tip="Getting Loans..."></Spin>
      </div>
    );
  }

  return (
    <Container>
      <TableButtonsContainer>
        <SpaceBetween>
          <div className="org-inpup-container">
            <Input
              size="large"
              onChange={() => null}
              placeholder="Search by name"
              prefix={<SearchOutlined />}
            />
          </div>
        </SpaceBetween>
      </TableButtonsContainer>

      <TableContainer>
        <Table columns={columns} dataSource={loans} />
      </TableContainer>
    </Container>
  );
}

const mapStateToProps = (state) => {
  return {
    loans: state.loansReducer.loans,
    loadingGetLoans: state.loansReducer.loadingGetLoans,
    errorGettingLoans: state.loansReducer.errorGettingLoans,
  };
};

export default connect(mapStateToProps, {
  getLoans,
  updateLoanStatus,
  setLoan,
})(Users);
